import { Injectable } from '@angular/core';

@Injectable()
export class UtilitiesService {
    public static convertDistrictNumberToDistrictName(districtNumber: string): string {
        switch(districtNumber) {
            case '01':
                return 'Edmonton NAHQ';
            case '02':
                return 'Resources';
            case '04':
                return 'Calgary';
            case '05':
                return 'Edmonton Buildings';
            case '06':
                return 'Regina';
            case '08':
                return 'Winnipeg';
            case '09':
                return 'Toronto';
            case '10':
                return 'Ottawa';
            case '13':
                return 'Edmonton Industrial Mgmt';
            case '15':
                return 'Edmonton Industrial';
            case '18':
                return 'Montreal';
            case '21':
                return 'Edmonton Energy';
            case '22':
                return 'BC Region';
            case '24':
                return 'Atlantic Canada';
            case '26':
                return 'Edmonton Melloy';
            case '28':
                return 'Saskatoon';
            case '32': 
                return 'Dalcon';
            case '50':
                return 'Denver';
            case '51':
                return "Minneapolis";
            case '52':
                return 'California Buildings';
            case '53':
                return 'Phoenix Buildings';
            case '54':
                return 'Civil West';
            case '55':
                return 'Civil East';
            case '56':
                return 'US Head Office';
            case '57':
                return 'Seattle';
            case '61':
                return 'Orlando';
            case '62':
                return 'Arizona Industrial';
            case '63':
                return 'US PICCo';
            case '66':
                return 'Hawaii';
            case '69': 
                return 'Nassal';
            case '77':
                return 'Digital Infrastructure';
            case '91':
                return 'Australia';
            case '92':
                return 'Solar Canada';
            case '93':
                return 'Solar USA';
            case '94':
                return 'Solar Australia';
            default:
                return 'Invalid DistrictNumber';
        }
     
    }
}
